export const SECRETS = {
  google_api_key: 'AIzaSyByZFNoHjqYG6rF5SucvQHwT9COCtphggs',
  stripe_api_key: 'pk_test_LBlXVqlojm27kh3l8JFv5WPh',
  facebook_app_id: '1004868106302719'
};



// WEBPACK FOOTER //
// ./src/constants/secrets.ts